<template>
  <div class="result-wrap">
    <back-button :tag="false" />
    <van-row v-if="peoples" class="stat-header">
      <van-col span="12"> 累计参赛人数：{{ peoples }} </van-col>
      <van-col span="12"> 累计参赛人次：{{ times }}</van-col>
    </van-row>
    <van-tabs
      class="custom-tabs"
      v-model="activeTab"
      color="#FFD36E"
      background="transparent"
      title-active-color="#FFD36E "
      title-inactive-color="#fff"
      line-width="25"
      line-height="3"
      swipeable
      animated
    >
      <!-- <van-tab title="市榜" title-class="custom-tab">
        <div class="tab-card">
          <city-list :weeks="weekList" />
        </div>
      </van-tab> -->
      <!-- <van-tab title="区县榜" title-class="custom-tab">
        <div class="tab-card">
          <county-list :weeks="weekList" />
        </div>
      </van-tab>
      <van-tab title="乡镇街道榜" title-class="custom-tab">
        <div class="tab-card">
          <town-list :weeks="weekList" />
        </div>
      </van-tab> -->
      <van-tab title="个人榜" title-class="custom-tab">
        <div class="tab-card">
          <individual-list :weeks="weekList" />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
// import CityList from "./CityList";
// import CountyList from "./CountyList";
import IndividualList from "./IndividualList";
// import TownList from "./TownList";
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    // CityList,
    // CountyList,
    IndividualList,
    // TownList,
    BackButton,
  },
  data() {
    return {
      activeTab: 0,
      weekList: [],
      peoples: 0,
      times: 0,
    };
  },
  methods: {
    async getWeekList() {
      try {
        const res = await this.$axios.post(`/Statis/week`);
        this.weekList = (res.data || []).map((item, index) => {
          return {
            code: item,
            text: "第  " + `${index + 1}` + "  周",
          };
        });
        if (this.weekList && this.weekList.length > 0) {
          this.weekList.unshift({ code: 0, text: "全部时段" });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || `获取周期数据失败`,
          duration: 2000,
        });
        this.$router.push("/");
      }
    },
    async getStatisTotal() {
      try {
        const res = await this.$axios.post(`/Statis/getTotal`);
        this.peoples = res.data.peoples;
        this.times = res.data.times;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || `获取统计数据失败`,
          duration: 2000,
        });
      }
    },
  },
  created() {
    this.getWeekList();
    this.getStatisTotal();
  },
};
</script>
<style lang="scss" scoped>
.result-wrap {
  box-sizing: border-box;
  min-height: 100vh;
  overflow: hidden;
  @include plain-bg;
  .stat-header {
    padding: 8px 10px;
    font-size: 14px;
    line-height: 15px;
    color: #ffd36e;
    text-align: center;
  }
}
.van-tabs {
  ::v-deep .van-tabs__nav {
    padding-right: 10px;
    padding-left: 10px;
  }
}
</style>
